/**
 * Mobile - Cart items molecule.
 */

// Imports
import {
  get as getCart,
} from '../MobileCart';
import {
  cartUpdateEventName,
  registerCallback as registerEventCallback,
} from '../../common/Events';
import {
  updateSkusList,
} from '../../common/Cart';
import cartQuickLinkId from '../../common/molecule/cart-items';

function handleCartUpdate(aoEvent, abSuccess) {
  if (!abSuccess) {
    return;
  }

  // Update the skus list
  updateSkusList(getCart());
}

function init() {
  if ($(`#${cartQuickLinkId}`).length) {
    // Register callback for cart update
    registerEventCallback({
      target: document,
      events: cartUpdateEventName,
      handler: handleCartUpdate,
    });

    updateSkusList(getCart());
  }
}

export default init;



// WEBPACK FOOTER //
// ./js/mobile/molecule/cart-items.js